import type { ReactNode } from 'react';

/** Đầu trang thống nhất: tiêu đề slab + câu hỏi của khu + (tuỳ chọn) hành động bên phải. */
export default function PageHeader({ title, question, children, className }: { title: string; question?: ReactNode; children?: ReactNode; className?: string }) {
  return (
    <div className={`flex flex-wrap items-start justify-between gap-3 ${className ?? ''}`}>
      <div className="min-w-0">
        <h1 className="font-slab text-3xl font-bold tracking-tight">{title}</h1>
        {question && <p className="mt-1 max-w-prose text-muted-foreground">{question}</p>}
      </div>
      {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
    </div>
  );
}
